module.exports = __webpack_public_path__ + "static/media/line-items-icon.83127b2f.svg";